import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";

// components
// import Navbar from "../components/navbar/Navbar";
import InvestmentsHeader from "../components/investments/InvestmentsHeader";
import PortfolioSummary from "../components/investments/PortfolioSummary";
// import Map from "../components/investments/Map";
import AssetGalleryGrid from "../components/investments/AssetGalleryGrid";
import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

// import ReChartsTest from "../components/investments/ReChartsTest";

import StoreLocator from "../components/investments/StoreLocator";

const InvestmentsWrapper = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_metrics.json`;

  const [fetchedData, setFetchedData] = useState([]);

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data.product.footnote);
    setFetchedData(data.product.footnote);
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const currentPage = window.location.pathname;
    ReactGA.send({
      hitType: "pageview",
      page: "/investments",
      title: "investments",
    });
    // console.log("GA Page View Sent:", currentPage); // Debugging
  }, []);
  return (
    <>
      {/* <Navbar /> */}
      <InvestmentsHeader />
      <PortfolioSummary />
      {/* <ReChartsTest /> */}
      <StoreLocator />
      {/* <Map /> */}
      <AssetGalleryGrid />
      <PrePreFooter>
        <ol className="list-decimal">
          {fetchedData.map((footNote) => {
            return <li className="text-base">{footNote.footnote}</li>;
          })}
          <li className="text-base">
            Represents DIR's ownership interest in the asset.
          </li>
        </ol>
        <p className="text-base mt-8">
          Metrics are unaudited and may be subject to rounding. Unless otherwise
          noted, all assets pictured are for illustrative purposes only and not
          owned by DIR. However, they are representative of the types of assets
          DIR expects to acquire.
        </p>
      </PrePreFooter>
      <PreFooter />
      <Footer />
    </>
  );
};

export default InvestmentsWrapper;
